
import { writable } from 'svelte/store';

export const pals = writable(JSON.parse(localStorage.getItem("userData")) || [])
pals.subscribe((value) => localStorage.userData = JSON.stringify(value))

function dateOrdinal(d) {
    return d+(31==d||21==d||1==d?"st":22==d||2==d?"nd":23==d||3==d?"rd":"th")
};  

export function niceContact(last_contacted) {
    if (last_contacted == "") {
        return "N/A"
    } else if (last_contacted == "-") {
        return ""
    }
    
    let mydate = new Date(last_contacted)

    var str = mydate.toDateString().split(' ').slice(1,3)
    return dateOrdinal(str[1]) + ' ' + str[0]
    // TODO: This should be somewhere else
}

export function UserData(name) {
    var key = (Math.random() + 1).toString(36).substring(5);
    this.key = key;
    this.name = name;
    this.last_contacted = "";
    this.notes = "";

}

export const show_remove = writable(false);
export const show_settings = writable(false)

export const warning_colour = writable(localStorage.getItem("warningColour")|| "red");
warning_colour.subscribe((value) => localStorage.warningColour = String(value))

export const warning_days = writable(localStorage.getItem("warningDays") || 7)
warning_days.subscribe((value) => localStorage.warningDays = value)

export const warning_date = writable("")


